import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { DocumentI } from '../../../types';

interface Props {
  document: DocumentI;
  options: Record<string, any>;
}
const PlainText = ({ document, options }: Props) => {
  const result = documentToPlainTextString(
    JSON.parse(document?.raw || '{}'),
    options || {},
  );

  // This is a weird, roundabout way of doing this, but it's the only thing that worked reliably
  return result
    .replace(/<\/?sup>(TM|MD|MC)?/gi, '')
    .replace(/\[object object\]/gi, '');
};

export default PlainText;
